<script setup>
import { calculateAge } from '@/libraries/HelperFunctions';

const props = defineProps(['patient']); 
const emits = defineEmits(['openPatient']);

function openPatient() {
  emits('openPatient')
}
</script>
<template>
  <div @click="openPatient" class="information-display">
            <div style="flex: 1">
              <div style="font-size: 150%">{{ patient.name }}</div>
              <div class="input">ID {{ patient.cr }}</div>
            </div>
            <div style="color: #777; text-align: right">
              <div>DOB {{ patient.dateOfBirth }}</div>
              <div>{{ calculateAge(new Date(patient.dateOfBirth)) }} yrs</div>
            </div>
          </div>
</template>
<style lang="scss" scoped>
.information-display {
  display: flex;
  margin: -10px -10px 15px -10px;
  padding: 10px 10px 3px 10px;
  border-bottom: solid 1px #ccc;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;

  cursor: pointer;

  &:hover {
    background-color: #f4f4f4;
  }
}</style>